import * as React from 'react';
import { Header2 } from '@cian/ui-kit/typography';
import { Button } from '@cian/ui-kit/button';

import * as styles from './styles.css';

interface INewbuildingConsultBannerProps {
  onChatClick(): void;
}

export function NewbuildingConsultBanner({ onChatClick }: INewbuildingConsultBannerProps) {
  return (
    <div className={styles['container']}>
      <Header2>
        Есть вопросы про новостройки?
        <br />
        Проконсультируйтесь в чате!
      </Header2>
      <div className={styles['btn-container']}>
        <Button size="XS" theme="fill_primary" onClick={onChatClick}>
          Написать в чат
        </Button>
        {/* <Button size="XS" theme="stroke_primary">
          Заказать звонок
        </Button> */}
      </div>
    </div>
  );
}
